import React from 'react'
import { observer } from 'mobx-react-lite'
import useCountryExplorationSubmission from './hooks/useCountryExplorationSubmission'
import s from './styles/CountryExplorationSubmission.module.scss'
import sharedStyles from '../shared/submissionStyles.module.scss'

const CountryExplorationSubmission = observer(({ assignment, student }) => {
	const { countries, isLoading, responseText, hasResponse } = useCountryExplorationSubmission({
		assignment,
		student,
	})

	return (
		<div className={s.container}>
			<div className={sharedStyles.submission}>
				<div className={sharedStyles.submission__inner}>
					<span className={sharedStyles.title}>SUBMISSION</span>

					<div className={sharedStyles.section}>
						<span className={sharedStyles.section__title}>
							Country Selected
						</span>
						<div className={sharedStyles.badgesList}>
							{isLoading ? (
								<div className={sharedStyles.loading}>Loading countries...</div>
							) : countries && countries.length > 0 ? (
								countries.map((country, index) => {
									const countryName =
										typeof country === 'string'
											? country
											: country?.name ||
												country?.countryName ||
												country?.title ||
												'Unknown Country'
									return (
										<span
											key={`country-${index}-${countryName}`}
											className={sharedStyles.pill}
										>
											{countryName}
										</span>
									)
								})
							) : (
								<div className={sharedStyles.empty}>
									No countries have been selected yet
								</div>
							)}
						</div>
					</div>

					<div className={sharedStyles.section}>
						<span className={sharedStyles.section__title}>
							Student's Response
						</span>
						<div className={sharedStyles.textArea}>
							{hasResponse ? (
								<p className={sharedStyles.textContent}>{responseText}</p>
							) : (
								<div className={sharedStyles.empty}>
									No response submitted yet
								</div>
							)}
						</div>
					</div>
				</div>
			</div>
		</div>
	)
})

CountryExplorationSubmission.displayName = 'CountryExplorationSubmission'

export default CountryExplorationSubmission
